import { render } from "./TokenExpirationTimer.vue?vue&type=template&id=0194c124&scoped=true"
import script from "./TokenExpirationTimer.vue?vue&type=script&lang=js"
export * from "./TokenExpirationTimer.vue?vue&type=script&lang=js"

import "./TokenExpirationTimer.vue?vue&type=style&index=0&id=0194c124&scoped=true&lang=css"

import exportComponent from "E:\\Projetos Web\\web-vida-vascular\\web-vidavascularjf-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0194c124"]])

export default __exports__